// Autogenerated by script
import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const HomeInverted: typeof SvgIcon & { activeColor: string } = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M21.41 9.965 12.6 2.232a.896.896 0 0 0-1.2.001L8.052 5.209V4.394a.948.948 0 0 0-.929-.948H4.336a.948.948 0 0 0-.93.948v.016-.001 4.665l-.916.951a1.694 1.694 0 0 0-.477 1.181v9.135c0 .905.724 1.64 1.625 1.659H8.986a1 1 0 0 0 1-1v-5.851a1 1 0 0 1 1-1h2.025a1 1 0 0 1 1 1V21a1 1 0 0 0 1 1h5.35a1.659 1.659 0 0 0 1.626-1.659v-.03.001V11.247c0-.509-.222-.967-.574-1.282l-.002-.001v.001Z" />
  </SvgIcon>
);

HomeInverted.activeColor = 'inherit';
HomeInverted.muiName = 'HomeInverted';
